import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import Button from 'components/Button';
import DownloadQr from './Layouts/downloadQr';
import { isEmpty } from 'lodash';
import { toggleModal } from 'reducers/ui';
import { PANEL } from 'utils/constants';
import { connect } from 'react-redux';

const useStyles = makeStyles(() => ({
  operational: {
    padding: '0rem 1rem',

    '& > *': {
      marginBottom: '1rem',
    },
  },
}));

const Operation = ({
  id,
  details,
  rawDetails,
  toggleModal,
  setFormProps,
  canCopyTemplate,
}) => {
  const classes = useStyles();

  const onClick = () => {
    setFormProps({
      openFormWithTemplate: true,
      templateDetails: { raw: rawDetails, id },
    });
    toggleModal();
  };

  const taskIsTemplate = isEmpty(details)
    ? false
    : details.others.isTemplate.value;

  return (
    <div className={classes.operational}>
      <DownloadQr id={id} />
      {taskIsTemplate && canCopyTemplate && (
        <Button text="Copy existing template" onClick={onClick} size="auto" />
      )}
    </div>
  );
};

Operation.propTypes = {
  id: PropTypes.string,
  details: PropTypes.object,
  rawDetails: PropTypes.object,
  toggleModal: PropTypes.func,
  setFormProps: PropTypes.func,
  canCopyTemplate: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  toggleModal: () => dispatch(toggleModal(PANEL.CLEANER_TASK)),
});

export default connect(null, mapDispatchToProps)(Operation);
